import { currencyFormatter } from 'helpers/formatters';
import { validCurrencyValue } from 'helpers/validators';

import React, { Fragment, useState } from 'react';

import { Trans } from '@lingui/macro';

import { ImageMedium } from 'components/Image';
import removeIcon from 'assets/images/close.svg';

import Button from 'components/Button';

import DebounceInput from './DebounceInput';

const CartItem = ({
  cartUUID,
  UUID,
  monthlyPrice,
  price,
  imgURL,
  name,
  actionRemove,
  actionable,
  isCTO,
  currency,
  language,
  quantity = 1,
  totalPrice,
  changeQuantity = () => {},
  changeSalePrice = () => {},
  useQuantities,
  canChangeSalePrice,
  marginAmount,
  costPrice,
  marginPercent,
  displayMargin,
}) => {
  const [quantityValue, setQuantityValue] = useState(quantity);

  const renderImage = () => {
    if (isCTO) {
      return (
        <Fragment>
          <span className='manual-cto-img'>
            <Trans id='order.cto.extra.badge'>CTO</Trans>
          </span>
        </Fragment>
      );
    } else {
      return <ImageMedium src={imgURL} alt={name} />;
    }
  };

  return (
    <tr>
      <td>
        <div className='cart-item-img-wrapper'>{renderImage()}</div>
        <span>{name}</span>
      </td>
      {displayMargin && (
        <>
          <td>
            <span>{currencyFormatter(costPrice, currency, language)}</span>
          </td>
          <td>
            <span>{currencyFormatter(marginAmount, currency, language)}</span>
          </td>
          <td>
            <span>{marginPercent}</span>
          </td>
        </>
      )}
      <td>
        <DebounceInput
          className={
            canChangeSalePrice
              ? 'cart-item-unit-price'
              : 'cart-item-unit-price-none'
          }
          min='1'
          type='text'
          disabled={!canChangeSalePrice}
          inputValue={price}
          formatter={(value) => currencyFormatter(value, currency, language)}
          onChange={(value) => changeSalePrice(cartUUID, UUID, value)}
          validator={(value) => validCurrencyValue(value)}
        />
      </td>
      {useQuantities && (
        <td>
          <DebounceInput
            className={`cart-item-quantity cart-item-quantity-${useQuantities}`}
            min={'1'}
            type='number'
            disabled={!useQuantities}
            inputValue={quantityValue}
            onChange={(value) => {
              setQuantityValue(value);
              changeQuantity(cartUUID, UUID, value);
            }}
          />
        </td>
      )}
      <td>
        <span>{currencyFormatter(totalPrice, currency, language)}</span>
      </td>
      <td>
        <span>{currencyFormatter(monthlyPrice, currency, language)}</span>
      </td>
      <td>
        {actionable ? (
          <Button classes='action-content' onClick={actionRemove}>
            <img className='remove' src={removeIcon} alt='remove' />
          </Button>
        ) : (
          <span className='action-content' />
        )}
      </td>
    </tr>
  );
};

export default CartItem;
